import styled from '@emotion/styled'
import { SyntheticEvent, memo } from 'react'
import { useModelColor } from '../../Hooks/useModelColor'
import { useUserSelector } from '../../Hooks/useUser'
import BadgeAvatar from '../../common/BadgeAvatar'
import { StyledName } from '../../common/Name'

export const AVATAR_SIZE = 40

const NameRoot = styled('span')({
    alignContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flex: 'auto',
    flexFlow: 'row nowrap',
    fontSize: '0.875rem',
    fontWeight: 600,
    justifyContent: 'flex-start',
})
// const StyledName = styled(Name)({
//     paddingLeft: getThemeSpacing(1),
//     fontSize: '0.8125rem',
//     margin: 0,
// })

interface INoteName {
    addBoxShadow?: boolean
    appendColon?: boolean
    onClick?(e: SyntheticEvent): void
    showAvatar?: boolean
    small?: boolean
    styleOverrides?: any
    username: string
    userId?: number
    skipLookup?: boolean
    isOnline?: boolean
}

const NoteName = memo((props: INoteName) => {
    const {
        addBoxShadow = false,
        appendColon = false,
        showAvatar = true,
        styleOverrides,
        skipLookup,
        isOnline,
        username,
        onClick,
        userId: id,
    } = props
    const color = useUserSelector(id, 'color', { lookup: !skipLookup })
    const isOffline = useUserSelector(id, 'isOffline') ?? !isOnline
    const isBroadcasting = useUserSelector(id, 'isBroadcasting')

    const userColor = useModelColor(color)

    if (!username) return null

    const Avatar = showAvatar ? (
        id ? (
            <BadgeAvatar
                alt={username}
                broadcasting={isBroadcasting}
                id={id}
                offline={isOffline}
                disableBadge={false}
                // disableBadge={
                //     isBroadcasting === undefined && isOffline === undefined
                // }
                onClick={onClick}
                size={AVATAR_SIZE}
                addBoxShadow={addBoxShadow}
            />
        ) : (
            <BadgeAvatar
                alt={username}
                offline={true}
                disableBadge={true}
                size={AVATAR_SIZE}
                addBoxShadow={addBoxShadow}
            />
        )
    ) : null

    return (
        <NameRoot css={styleOverrides} data-testid="News__NameRoot">
            {Avatar}
            <StyledName
                text={username + (appendColon ? ':' : '')}
                color={userColor}
            />
        </NameRoot>
    )
})

export default NoteName
